import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NavLink = ({ label, to, onClick }) => {
  if (onClick) {
    return (
      <button
        onClick={onClick}
        className="relative py-2 px-1 text-sm font-semibold text-slate-700 after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-blue-500 after:transition-all after:duration-300 hover:after:w-full"
      >
        {label}
      </button>
    );
  }

  return (
    <Link
      to={to}
      className="relative py-2 px-1 text-sm font-semibold text-slate-700 after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-blue-500 after:transition-all after:duration-300 hover:after:w-full"
    >
      {label}
    </Link>
  );
};

NavLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

export default NavLink;
